module.exports = __webpack_public_path__ + "static/media/cicd.52e226fd.svg";